import {
	type AdverseEventContactEntry,
	type AdverseEventsFormValues,
} from '#app/routes/mocra+/_form+/adverse-events/form.ts'

export type AdverseEventContactKey =
	| 'seriousEventContacts'
	| 'followUpContacts'
	| 'trendAlertContacts'

export interface ContactSectionMeta {
	readonly key: AdverseEventContactKey
	readonly title: string
	readonly description: string
	readonly emptyState: string
}

const SECTION_DEFINITIONS: Record<AdverseEventContactKey, ContactSectionMeta> =
	{
		seriousEventContacts: {
			key: 'seriousEventContacts',
			title: 'Serious adverse events contacts',
			description:
				'Escalate immediately when hospitalizations, life-threatening events, or significant medical outcomes surface.',
			emptyState:
				'Add the people who must be paged for serious adverse events so no critical case is missed.',
		},
		followUpContacts: {
			key: 'followUpContacts',
			title: 'Complaint follow-up',
			description:
				'Outline the steady-state complaint triage team for routine issues that still need timely follow-up.',
			emptyState:
				'Capture the default complaint escalation chain so every reported issue receives a response.',
		},
		trendAlertContacts: {
			key: 'trendAlertContacts',
			title: 'Trend alerts & spikes',
			description:
				'Notify analytics, quality, or operations leads who monitor spikes and coordinate broader responses.',
			emptyState:
				'Include the people who analyze complaint spikes so they can jump in when metrics cross thresholds.',
		},
	}

export const CONTACT_SECTIONS: readonly ContactSectionMeta[] = [
	SECTION_DEFINITIONS.seriousEventContacts,
	SECTION_DEFINITIONS.followUpContacts,
	SECTION_DEFINITIONS.trendAlertContacts,
]

export function getContactSectionMeta(
	key: AdverseEventContactKey,
): ContactSectionMeta {
	return SECTION_DEFINITIONS[key]
}

export function getContactsForSection(
	data: Pick<AdverseEventsFormValues, AdverseEventContactKey> | undefined,
	key: AdverseEventContactKey,
): readonly AdverseEventContactEntry[] {
	if (!data) return []
	const bucket = data[key]
	return Array.isArray(bucket) ? bucket : []
}
